
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/expressing-empathy-in-islam",
      function () {
        return require("private-next-pages/articles/expressing-empathy-in-islam.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/expressing-empathy-in-islam"])
      });
    }
  